/**
 * PAGE LAYOUT
 * Wrapper principal pour toutes les pages de liste
 * Supporte les SidePanels en mode "push" (décale le contenu)
 *
 * Structure:
 * - Header en haut (fixe)
 * - Contenu principal + SidePanel (flex horizontal)
 */

import { type ReactNode } from 'react';

interface PageLayoutProps {
  header?: ReactNode; // PageHeader qui reste en haut
  children: ReactNode; // Contenu principal
  sidePanel?: ReactNode; // SidePanel optionnel qui s'affiche à droite
}

export function PageLayout({ header, children, sidePanel }: PageLayoutProps) {
  return (
    <div className="flex flex-col h-full w-full bg-neutral-50">
      {/* Header - Reste en haut */}
      {header}

      {/* Conteneur flex horizontal pour le contenu + SidePanel */}
      <div className="flex h-full w-full overflow-hidden">
        {/* Contenu principal */}
        <div className="flex flex-col h-full w-full overflow-auto">{children}</div>

        {/* SidePanel (si fourni) - Positionné à droite */}
        {sidePanel}
      </div>
    </div>
  );
}
